import { BetSelection, MarketType } from '@/constants';
import { marketTypeDictionary } from '@/stores/simpleDictionary/marketType';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';
import type { IBetSelectionDictionaryItem } from '@/types';

const dictionary = createSimpleDictionary<IBetSelectionDictionaryItem>(
    [
        { id: BetSelection.HandicapHome, name: 'dictionaries.betSelection.handicapHome', marketTypeId: MarketType.Handicap },
        { id: BetSelection.HandicapAway, name: 'dictionaries.betSelection.handicapAway', marketTypeId: MarketType.Handicap },
        { id: BetSelection.GoalOver, name: 'dictionaries.betSelection.goalOver', marketTypeId: MarketType.Goal },
        { id: BetSelection.GoalUnder, name: 'dictionaries.betSelection.goalUnder', marketTypeId: MarketType.Goal },
        { id: BetSelection.OneXTwoHome, name: 'dictionaries.betSelection.oneXTwoHome', marketTypeId: MarketType.OneXTwo },
        { id: BetSelection.OneXTwoDraw, name: 'dictionaries.betSelection.oneXTwoDraw', marketTypeId: MarketType.OneXTwo },
        { id: BetSelection.OneXTwoAway, name: 'dictionaries.betSelection.oneXTwoAway', marketTypeId: MarketType.OneXTwo },
        { id: BetSelection.BtsYes, name: 'dictionaries.betSelection.btsYes', marketTypeId: MarketType.Bts },
        { id: BetSelection.BtsNo, name: 'dictionaries.betSelection.btsNo', marketTypeId: MarketType.Bts },
        { id: BetSelection.Dc1X, name: 'dictionaries.betSelection.dc1X', marketTypeId: MarketType.Dc },
        { id: BetSelection.Dc12, name: 'dictionaries.betSelection.dc12', marketTypeId: MarketType.Dc },
        { id: BetSelection.DcX2, name: 'dictionaries.betSelection.dcX2', marketTypeId: MarketType.Dc },
        { id: BetSelection.Cs, name: 'dictionaries.betSelection.cs', marketTypeId: MarketType.Cs },
        { id: BetSelection.CornersHandicapHome, name: 'dictionaries.betSelection.cornersHandicapHome', marketTypeId: MarketType.CornersHandicap },
        { id: BetSelection.CornersHandicapAway, name: 'dictionaries.betSelection.cornersHandicapAway', marketTypeId: MarketType.CornersHandicap },
        { id: BetSelection.CornersGoalOver, name: 'dictionaries.betSelection.cornersGoalOver', marketTypeId: MarketType.CornersGoal },
        { id: BetSelection.CornersGoalUnder, name: 'dictionaries.betSelection.cornersGoalUnder', marketTypeId: MarketType.CornersGoal },
        { id: BetSelection.GoalHomeOver, name: 'dictionaries.betSelection.goalHomeOver', marketTypeId: MarketType.GoalHome },
        { id: BetSelection.GoalHomeUnder, name: 'dictionaries.betSelection.goalHomeUnder', marketTypeId: MarketType.GoalHome },
        { id: BetSelection.GoalAwayOver, name: 'dictionaries.betSelection.goalAwayOver', marketTypeId: MarketType.GoalAway },
        { id: BetSelection.GoalAwayUnder, name: 'dictionaries.betSelection.goalAwayUnder', marketTypeId: MarketType.GoalAway },
        { id: BetSelection.DrawNoBetHome, name: 'dictionaries.betSelection.drawNoBetHome', marketTypeId: MarketType.DrawNoBet },
        { id: BetSelection.DrawNoBetAway, name: 'dictionaries.betSelection.drawNoBetAway', marketTypeId: MarketType.DrawNoBet },
        { id: BetSelection.MoneylineHome, name: 'dictionaries.betSelection.moneylineHome', marketTypeId: MarketType.Moneyline },
        { id: BetSelection.MoneylineAway, name: 'dictionaries.betSelection.moneylineAway', marketTypeId: MarketType.Moneyline },
        { id: BetSelection.SpreadHome, name: 'dictionaries.betSelection.spreadHome', marketTypeId: MarketType.Spread },
        { id: BetSelection.SpreadAway, name: 'dictionaries.betSelection.spreadAway', marketTypeId: MarketType.Spread },
    ],
    ['name']
);

function nameWithMarket(id: number | string, marketField: 'name' | 'shortName', separator: string): string {
    const item = dictionary.itemById(id);
    const market = marketTypeDictionary.itemById(item.marketTypeId);
    const marketName = (marketField === 'shortName' ? market.shortName : market.name) || market.name;

    return item.name ? `${marketName}${separator}${item.name}` : marketName;
}

export const betSelectionDictionary = Object.assign(dictionary, {
    getName(id: number | string): string {
        return dictionary.nameById(id);
    },
    getNameWithFullMarket(id: number | string): string {
        return nameWithMarket(id, 'name', ' - ');
    },
    getNameWithShortMarket(id: number | string): string {
        return nameWithMarket(id, 'shortName', ' ');
    },
});
